<div class="tracking-dashboard flex flex-column gap-4">
  <!-- Global Filter Card -->
  <div class="card p-4 surface-card border-round shadow-1">
    <h3
      class="m-0 mb-3 text-base font-semibold flex align-items-center gap-2 text-700">
      <i class="fas fa-filter"></i> Filter
    </h3>
    <div class="grid p-fluid">
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-from"
          class="block text-sm font-medium text-600 mb-1"
          >Von Datum</label
        >
        <p-calendar
          inputId="tracking-filter-from"
          [(ngModel)]="fromDate"
          dateFormat="dd.mm.yy"
          placeholder="Startdatum"
          [showIcon]="true"
          [showButtonBar]="true"></p-calendar>
      </div>
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-to"
          class="block text-sm font-medium text-600 mb-1"
          >Bis Datum</label
        >
        <p-calendar
          inputId="tracking-filter-to"
          [(ngModel)]="toDate"
          dateFormat="dd.mm.yy"
          placeholder="Enddatum"
          [showIcon]="true"
          [showButtonBar]="true"></p-calendar>
      </div>
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-type"
          class="block text-sm font-medium text-600 mb-1"
          >Event-Typ</label
        >
        <p-dropdown
          [options]="typeOptions"
          inputId="tracking-filter-type"
          [(ngModel)]="filterType"
          placeholder="Typ filtern"></p-dropdown>
      </div>
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-context"
          class="block text-sm font-medium text-600 mb-1"
          >Kontext</label
        >
        <p-dropdown
          [options]="contextOptions"
          inputId="tracking-filter-context"
          [(ngModel)]="filterContext"
          placeholder="Kontext"></p-dropdown>
      </div>
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-user"
          class="block text-sm font-medium text-600 mb-1"
          >Benutzer</label
        >
        <p-dropdown
          [options]="getUserOptions()"
          inputId="tracking-filter-user"
          [(ngModel)]="filterUserId"
          placeholder="Benutzer filtern"
          [filter]="true"></p-dropdown>
      </div>
      <div class="col-12 sm:col-6 md:col-2" *ngIf="isSuperAdmin()">
        <label
          for="tracking-filter-commune"
          class="block text-sm font-medium text-600 mb-1"
          >Kommune</label
        >
        <p-dropdown
          [options]="getCommuneOptions()"
          inputId="tracking-filter-commune"
          [(ngModel)]="filterCommuneId"
          placeholder="Kommune filtern"
          [filter]="true"></p-dropdown>
      </div>
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-route"
          class="block text-sm font-medium text-600 mb-1"
          >Route (URL)</label
        >
        <p-dropdown
          [options]="routeUrlOptions"
          inputId="tracking-filter-route"
          [(ngModel)]="filterRouteUrl"
          placeholder="Route filtern"
          [filter]="true"
          filterPlaceholder="URL suchen…"></p-dropdown>
      </div>
      <div class="col-12 sm:col-6 md:col-2">
        <label
          for="tracking-filter-limit"
          class="block text-sm font-medium text-600 mb-1"
          >Max. Einträge</label
        >
        <input
          id="tracking-filter-limit"
          type="number"
          pInputText
          [(ngModel)]="filterLimit"
          placeholder="500"
          min="1"
          max="5000" />
      </div>
    </div>
    <div
      class="flex justify-content-between align-items-center gap-2 mt-3 border-top-1 surface-border pt-3">
      <div class="flex gap-2">
        <p-button
          icon="fas fa-file-export"
          label="CSV Export"
          severity="secondary"
          [outlined]="true"
          [rounded]="true"
          (onClick)="exportCSV()"></p-button>
      </div>
      <div class="flex gap-2">
        <p-button
          label="Zurücksetzen"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          (onClick)="resetFilters()"></p-button>
        <p-button
          label="Anwenden"
          icon="fas fa-search"
          [rounded]="true"
          [loading]="store.loading()"
          (onClick)="loadFilteredData()"></p-button>
      </div>
    </div>

    <!-- Active filter chips -->
    <div class="flex flex-wrap gap-2 mt-3" *ngIf="activeFilterChips.length">
      <button
        *ngFor="let chip of activeFilterChips"
        type="button"
        class="filter-chip"
        [attr.aria-label]="chip.label + ' entfernen'"
        (click)="removeFilter(chip.key)">
        {{ chip.label }} <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <!-- Summary Badges -->
  <div class="stat-grid">
    <div>
      <div class="stat-card">
        <div class="stat-icon icon-blue"><i class="fas fa-list"></i></div>
        <div>
          <div class="text-2xl font-bold text-900">
            {{ filteredItems.length }}
          </div>
          <div class="text-xs text-500">Geladene Events</div>
        </div>
      </div>
    </div>
    <div>
      <div class="stat-card">
        <div class="stat-icon icon-green"><i class="fas fa-route"></i></div>
        <div>
          <div class="text-2xl font-bold text-900">
            {{ viewRanking.length }}
          </div>
          <div class="text-xs text-500">Unique Routen</div>
        </div>
      </div>
    </div>
    <div>
      <div class="stat-card">
        <div class="stat-icon icon-amber"><i class="fas fa-globe"></i></div>
        <div>
          <div class="text-2xl font-bold text-900">
            {{ externalItems.length }}
          </div>
          <div class="text-xs text-500">Öffentliche Besuche</div>
        </div>
      </div>
    </div>
    <div>
      <div class="stat-card">
        <div class="stat-icon icon-indigo">
          <i class="fas fa-sign-in-alt"></i>
        </div>
        <div>
          <div class="text-2xl font-bold text-900">{{ loginItems.length }}</div>
          <div class="text-xs text-500">Logins</div>
        </div>
      </div>
    </div>
    <div>
      <div class="stat-card">
        <div class="stat-icon icon-rose"><i class="fas fa-users"></i></div>
        <div>
          <div class="text-2xl font-bold text-900">{{ activeUsersCount }}</div>
          <div class="text-xs text-500">Aktive Nutzer</div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="stat-card"
        [pTooltip]="
          peakSlot ? peakSlot.day + ', ' + peakSlot.hour + ':00 Uhr' : undefined
        ">
        <div class="stat-icon icon-purple"><i class="fas fa-fire"></i></div>
        <div>
          <div class="text-2xl font-bold text-900">
            {{ peakSlot ? peakSlot.day + ' ' + peakSlot.hour + 'h' : '–' }}
          </div>
          <div class="text-xs text-500">Stoßzeit</div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="stat-card"
        [pTooltip]="
          dwellSampleTotal ? dwellSampleTotal + ' Messwerte' : undefined
        ">
        <div class="stat-icon icon-teal">
          <i class="fas fa-hourglass-half"></i>
        </div>
        <div>
          <div class="text-2xl font-bold text-900">
            {{ formatDuration(overallAvgDwellSeconds) }}
          </div>
          <div class="text-xs text-500">Ø Verweildauer</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <p-tabView>
    <!-- ══════════════════ TAB 0: ÜBERSICHT ══════════════════ -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span><i class="fas fa-chart-area mr-2"></i>Übersicht</span>
      </ng-template>

      <div class="grid mt-3">
        <div
          class="col-12"
          [ngClass]="isSuperAdmin() ? 'lg:col-6' : 'lg:col-8'">
          <div
            class="card p-3 surface-card border-round shadow-1 flex flex-column"
            style="height: 20rem">
            <h3
              class="m-0 mb-2 text-sm font-semibold text-700 flex align-items-center gap-2">
              <i class="fas fa-chart-line"></i> Aktivität über Zeit
            </h3>
            <div class="chart-wrapper flex-grow-1">
              <p-chart
                *ngIf="lineData"
                type="line"
                [data]="lineData"
                [options]="lineOptions"></p-chart>
              <div
                *ngIf="!lineData"
                class="absolute w-full h-full flex align-items-center justify-content-center text-500">
                Keine Daten verfügbar
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-12"
          [ngClass]="isSuperAdmin() ? 'lg:col-3' : 'lg:col-4'">
          <div
            class="card p-3 surface-card border-round shadow-1 flex flex-column"
            style="height: 20rem">
            <h3
              class="m-0 mb-2 text-sm font-semibold text-700 flex align-items-center gap-2">
              <i class="fas fa-chart-bar"></i> Event-Typen
            </h3>
            <div class="chart-wrapper flex-grow-1">
              <p-chart
                *ngIf="barData"
                type="bar"
                [data]="barData"
                [options]="barOptions"></p-chart>
              <div
                *ngIf="!barData"
                class="absolute w-full h-full flex align-items-center justify-content-center text-500">
                Keine Daten verfügbar
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-3" *ngIf="isSuperAdmin()">
          <div
            class="card p-3 surface-card border-round shadow-1 flex flex-column"
            style="height: 20rem">
            <h3
              class="m-0 mb-2 text-sm font-semibold text-700 flex align-items-center gap-2">
              <i class="fas fa-chart-pie"></i> Aktivste Kommunen
            </h3>
            <div class="chart-wrapper flex-grow-1">
              <p-chart
                *ngIf="pieData"
                type="doughnut"
                [data]="pieData"
                [options]="pieOptions"></p-chart>
              <div
                *ngIf="!pieData"
                class="absolute w-full h-full flex align-items-center justify-content-center text-500">
                Keine Daten verfügbar
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Raw log table -->
      <div class="card surface-card border-round shadow-1 overflow-hidden mt-3">
        <div
          class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center">
          <span class="font-semibold text-700">Aktivitätsprotokolle</span>
          <span class="p-badge p-badge-info"
            >{{ filteredItems.length }} Einträge</span
          >
        </div>
        <p-table
          [value]="filteredItems"
          [loading]="store.loading()"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 25, 50]"
          styleClass="p-datatable-striped p-datatable-sm"
          responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 14%">
                <i class="fas fa-clock mr-1"></i> Zeitstempel
              </th>
              <th style="width: 11%"><i class="fas fa-tag mr-1"></i> Typ</th>
              <th style="width: 9%">
                <i class="fas fa-wifi mr-1"></i> Kontext
              </th>
              <th style="width: 8%"><i class="fas fa-bolt mr-1"></i> Aktion</th>
              <th style="width: 13%">
                <i class="fas fa-database mr-1"></i> Ziel
              </th>
              <th style="width: 22%">
                <i class="fas fa-user-shield mr-1"></i> Pseudonym
              </th>
              <th style="width: 23%">
                <i class="fas fa-info-circle mr-1"></i> Details
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td class="font-semibold text-700">
                {{ item.timestamp * 1000 | date: 'dd.MM.yy, HH:mm:ss' }}
              </td>
              <td>
                <span
                  [ngClass]="{
                    'bg-blue-50 text-blue-700 border-blue-200':
                      item.type === 'ROUTE_CHANGE',
                    'bg-amber-50 text-amber-700 border-amber-200':
                      item.type === 'CRUD',
                    'bg-emerald-50 text-emerald-700 border-emerald-200':
                      item.type === 'LOGIN',
                  }"
                  class="px-2 py-1 border-1 border-round text-xs font-semibold"
                  >{{ item.type }}</span
                >
              </td>
              <td>
                <span
                  [ngClass]="{
                    'text-amber-600':
                      item.isPublic || item.context === 'external',
                    'text-blue-600':
                      !item.isPublic && item.context !== 'external',
                  }"
                  class="text-xs font-medium">
                  <i
                    [class]="
                      item.isPublic || item.context === 'external'
                        ? 'fas fa-globe mr-1'
                        : 'fas fa-lock mr-1'
                    "></i>
                  {{
                    item.isPublic || item.context === 'external'
                      ? 'Extern'
                      : 'Intern'
                  }}
                </span>
              </td>
              <td class="font-medium">{{ item.action }}</td>
              <td class="text-600">{{ item.targetCollection || '-' }}</td>
              <td>
                <span
                  class="text-xs font-mono text-500 block"
                  style="
                    max-width: 14rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  [title]="item.userId"
                  >{{ item.userId || 'Anonym' }}</span
                >
              </td>
              <td>
                <div class="text-xs text-600">
                  <ng-container *ngIf="item.type === 'ROUTE_CHANGE'">
                    <span
                      *ngIf="item.details?.bookmarkId"
                      class="font-semibold text-indigo-700 block">
                      <i class="fas fa-bookmark mr-1"></i
                      >{{ resolveBookmarkTitle(item.details.bookmarkId) }}
                    </span>
                    <span class="text-400">{{
                      shortUrl(item.details?.url || '')
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="item.type === 'LOGIN'">
                    Methode:
                    <strong>{{ item.details?.method || 'Standard' }}</strong>
                    &nbsp;IP: {{ item.details?.ip || 'N/A' }}
                  </ng-container>
                  <ng-container *ngIf="item.type === 'CRUD'">
                    <strong>{{ item.details?.url }}</strong>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center py-5 text-500">
                <i class="fas fa-search-minus text-3xl mb-2 block"></i>
                Keine Einträge für die gewählten Filter.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>

    <!-- ══════════════════ TAB 1: ANSICHTEN-RANKING ══════════════════ -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span><i class="fas fa-eye mr-2"></i>Ansichten-Ranking</span>
      </ng-template>

      <div class="mt-3">
        <p class="text-500 text-sm mb-3">
          Nur Ansichten (Bookmarks, <code>/ansicht/:id</code>) nach
          Aufrufhäufigkeit. Der Titel der Ansicht wird automatisch aufgelöst
          (sofern nicht gelöscht). Intern = eingeloggte Nutzer &nbsp;|&nbsp;
          Extern = atlas-intern & öffentlicher Atlas.
          <br />
          <i class="fas fa-info-circle mr-1"></i>
          Die Ø Verweildauer ist eine Näherung aus der Zeitdifferenz zwischen
          zwei aufeinanderfolgenden Seitenaufrufen. Bei eingeloggten Nutzern
          wird über die echte Nutzerkennung gruppiert, bei anonymen Besuchen im
          öffentlichen Atlas über eine zufällige, im Browser gespeicherte
          Besucher-ID (kein Personenbezug). Pausen über 30 Minuten werden als
          Sitzungsende gewertet und nicht eingerechnet.
        </p>
        <div class="card surface-card border-round shadow-1 overflow-hidden">
          <div
            class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center gap-3 flex-wrap">
            <span class="font-semibold text-700"
              >Ansichten nach Häufigkeit</span
            >
            <div class="flex align-items-center gap-2">
              <label for="tracking-ranking-context" class="text-sm text-600"
                >Kontext:</label
              >
              <p-dropdown
                inputId="tracking-ranking-context"
                [options]="viewRankingContextOptions"
                [(ngModel)]="viewRankingContext"
                (onChange)="onViewRankingContextChange()"
                styleClass="w-14rem"></p-dropdown>
              <span class="p-badge p-badge-secondary"
                >{{ viewRanking.length }} Ansichten</span
              >
            </div>
          </div>
          <p-table
            [value]="viewRanking"
            [paginator]="true"
            [rows]="20"
            [rowsPerPageOptions]="[10, 20, 50]"
            styleClass="p-datatable-striped p-datatable-sm"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 4%">#</th>
                <th pSortableColumn="bookmarkTitle" style="width: 24%">
                  Ansicht <p-sortIcon field="bookmarkTitle"></p-sortIcon>
                </th>
                <th style="width: 22%">URL</th>
                <th pSortableColumn="total" style="width: 11%">
                  Gesamt <p-sortIcon field="total"></p-sortIcon>
                </th>
                <th pSortableColumn="internalCount" style="width: 10%">
                  <i class="fas fa-lock mr-1"></i>Intern
                  <p-sortIcon field="internalCount"></p-sortIcon>
                </th>
                <th pSortableColumn="externalCount" style="width: 11%">
                  <i class="fas fa-globe mr-1"></i>Extern
                  <p-sortIcon field="externalCount"></p-sortIcon>
                </th>
                <th pSortableColumn="avgDwellSeconds" style="width: 14%">
                  <i class="fas fa-hourglass-half mr-1"></i>Ø Verweildauer
                  <p-sortIcon field="avgDwellSeconds"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entry let-rowIndex="rowIndex">
              <tr>
                <td class="text-500 font-bold">{{ rowIndex + 1 }}</td>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i
                      [class]="
                        isAnsichtUrl(entry.url)
                          ? 'fas fa-bookmark text-indigo-500'
                          : 'fas fa-file text-600'
                      "></i>
                    <span class="font-medium">{{ entry.bookmarkTitle }}</span>
                  </div>
                </td>
                <td>
                  <span
                    class="text-xs font-mono text-400"
                    style="word-break: break-all"
                    >{{ entry.url }}</span
                  >
                </td>
                <td>
                  <div class="flex align-items-center gap-2">
                    <span class="font-bold text-900 text-lg">{{
                      entry.total
                    }}</span>
                    <div
                      class="flex-1 border-round bg-blue-50 overflow-hidden"
                      style="height: 6px; min-width: 30px">
                      <div
                        class="bg-blue-400 h-full border-round"
                        [style.width.%]="
                          viewRanking[0]?.total
                            ? (entry.total / viewRanking[0].total) * 100
                            : 0
                        "></div>
                    </div>
                  </div>
                </td>
                <td class="text-blue-700 font-semibold">
                  {{ entry.internalCount }}
                </td>
                <td class="text-amber-600 font-semibold">
                  {{ entry.externalCount }}
                </td>
                <td>
                  <span
                    *ngIf="entry.avgDwellSeconds !== null"
                    class="text-teal-700 font-semibold">
                    {{ formatDuration(entry.avgDwellSeconds) }}
                  </span>
                  <span
                    *ngIf="entry.avgDwellSeconds === null"
                    class="text-400 text-sm"
                    >–</span
                  >
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center py-5 text-500">
                  <i class="fas fa-route text-3xl mb-2 block"></i>
                  Keine Routenwechsel im gewählten Zeitraum.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>

    <!-- ══════════════════ TAB 2: LOGIN-ANALYSE ══════════════════ -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span><i class="fas fa-sign-in-alt mr-2"></i>Login-Analyse</span>
      </ng-template>

      <div class="mt-3">
        <div
          class="card p-3 surface-card border-round shadow-1 flex flex-column mb-4"
          style="height: 20rem">
          <h3
            class="m-0 mb-2 text-sm font-semibold text-700 flex align-items-center gap-2">
            <i class="fas fa-chart-line"></i> Login-Frequenz über Zeit
          </h3>
          <div class="chart-wrapper flex-grow-1">
            <p-chart
              *ngIf="loginLineData"
              type="line"
              [data]="loginLineData"
              [options]="loginLineOptions"></p-chart>
            <div
              *ngIf="!loginLineData"
              class="absolute w-full h-full flex align-items-center justify-content-center text-500">
              Keine Login-Daten im gewählten Zeitraum
            </div>
          </div>
        </div>

        <div class="card surface-card border-round shadow-1 overflow-hidden">
          <div
            class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center">
            <span class="font-semibold text-700">Login-Ereignisse</span>
            <span class="p-badge p-badge-success"
              >{{ loginItems.length }} Logins</span
            >
          </div>
          <p-table
            [value]="loginItems"
            [paginator]="true"
            [rows]="15"
            styleClass="p-datatable-striped p-datatable-sm"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 18%">
                  <i class="fas fa-clock mr-1"></i> Zeitstempel
                </th>
                <th style="width: 28%">
                  <i class="fas fa-user-shield mr-1"></i> Pseudonym
                </th>
                <th style="width: 18%">
                  <i class="fas fa-key mr-1"></i> Methode
                </th>
                <th style="width: 18%">
                  <i class="fas fa-network-wired mr-1"></i> IP
                </th>
                <th style="width: 18%">
                  <i class="fas fa-building mr-1"></i> Kommune
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="font-semibold text-700">
                  {{ item.timestamp * 1000 | date: 'dd.MM.yy, HH:mm:ss' }}
                </td>
                <td>
                  <span
                    class="text-xs font-mono text-500"
                    style="word-break: break-all">
                    {{ item.userId || 'Anonym' }}
                  </span>
                </td>
                <td>
                  <span
                    class="text-xs px-2 py-1 border-round border-1 border-green-200 bg-green-50 text-green-700 font-medium">
                    {{ item.details?.method || 'Standard' }}
                  </span>
                </td>
                <td class="text-600 text-sm">
                  {{ item.details?.ip || 'N/A' }}
                </td>
                <td class="text-600 text-sm">
                  {{ getCommuneName(item.communeId) }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center py-5 text-500">
                  <i class="fas fa-sign-in-alt text-3xl mb-2 block"></i>
                  Keine Login-Ereignisse im gewählten Zeitraum.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>

    <!-- ══════════════════ TAB 3: INTERN VS. EXTERN ══════════════════ -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span><i class="fas fa-code-branch mr-2"></i>Intern vs. Extern</span>
      </ng-template>

      <div class="mt-3">
        <div class="grid mb-4">
          <div class="col-12 md:col-6">
            <div
              class="card p-4 surface-card border-round shadow-1 border-left-3 border-blue-500">
              <div class="flex align-items-center gap-3">
                <i class="fas fa-lock text-blue-500 text-3xl"></i>
                <div>
                  <div class="text-3xl font-bold text-900">
                    {{ internalItems.length }}
                  </div>
                  <div class="text-500">
                    Interne Routenwechsel (eingeloggte Nutzer)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="card p-4 surface-card border-round shadow-1 border-left-3 border-amber-500">
              <div class="flex align-items-center gap-3">
                <i class="fas fa-globe text-amber-500 text-3xl"></i>
                <div>
                  <div class="text-3xl font-bold text-900">
                    {{ externalItems.length }}
                  </div>
                  <div class="text-500">
                    Externe Besuche (öffentlicher Atlas)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card p-3 surface-card border-round shadow-1 flex flex-column mb-4"
          style="height: 22rem">
          <h3
            class="m-0 mb-2 text-sm font-semibold text-700 flex align-items-center gap-2">
            <i class="fas fa-chart-line"></i> Intern vs. Extern über Zeit
          </h3>
          <div class="chart-wrapper flex-grow-1">
            <p-chart
              *ngIf="internalExternalData"
              type="line"
              [data]="internalExternalData"
              [options]="internalExternalOptions"></p-chart>
            <div
              *ngIf="!internalExternalData"
              class="absolute w-full h-full flex align-items-center justify-content-center text-500">
              Keine Routenwechsel im gewählten Zeitraum
            </div>
          </div>
        </div>

        <div
          class="card surface-card border-round shadow-1 overflow-hidden"
          *ngIf="externalItems.length > 0">
          <div class="p-3 border-bottom-1 surface-border">
            <span class="font-semibold text-700"
              >Meistbesuchte Seiten (Extern)</span
            >
          </div>
          <p-table
            [value]="viewRanking"
            [paginator]="true"
            [rows]="10"
            styleClass="p-datatable-striped p-datatable-sm"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 5%">#</th>
                <th style="width: 35%">Ansicht / Seite</th>
                <th style="width: 40%">URL</th>
                <th pSortableColumn="externalCount" style="width: 20%">
                  Externe Besuche
                  <p-sortIcon field="externalCount"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entry let-rowIndex="rowIndex">
              <tr *ngIf="entry.externalCount > 0">
                <td class="font-bold text-500">{{ rowIndex + 1 }}</td>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i
                      [class]="
                        isAnsichtUrl(entry.url)
                          ? 'fas fa-bookmark text-indigo-500'
                          : 'fas fa-file text-600'
                      "></i>
                    <span class="font-medium">{{ entry.bookmarkTitle }}</span>
                  </div>
                </td>
                <td>
                  <span class="text-xs font-mono text-400">{{
                    entry.url
                  }}</span>
                </td>
                <td class="text-amber-600 font-bold text-lg">
                  {{ entry.externalCount }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div
          *ngIf="externalItems.length === 0"
          class="card surface-card border-round shadow-1 p-5 text-center text-500">
          <i class="fas fa-globe text-3xl mb-2 block text-300"></i>
          Noch keine öffentlichen Besuche getrackt.
        </div>
      </div>
    </p-tabPanel>

    <!-- ══════════════════ TAB 4: AKTIVITÄTS-HEATMAP ══════════════════ -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span><i class="fas fa-fire mr-2"></i>Heatmap</span>
      </ng-template>

      <div class="mt-3">
        <p class="text-500 text-sm mb-3">
          Aktivität nach Wochentag und Uhrzeit. Dunklere Zellen zeigen mehr
          Events.
          <span *ngIf="peakSlot">
            Stoßzeit:
            <strong
              >{{ peakSlot.day }}, {{ peakSlot.hour }}:00–{{
                peakSlot.hour + 1
              }}:00 Uhr</strong
            >
            ({{ peakSlot.count }} Events).
          </span>
        </p>
        <div
          class="card p-3 surface-card border-round shadow-1 overflow-hidden">
          <div class="heatmap-scroll">
            <div class="heatmap-grid">
              <div class="heatmap-corner"></div>
              <div class="heatmap-hour-label" *ngFor="let h of hourLabels">
                {{ h }}
              </div>

              <ng-container
                *ngFor="let row of heatmapMatrix; let dayIndex = index">
                <div class="heatmap-day-label">
                  {{ weekdayLabels[dayIndex] }}
                </div>
                <div
                  class="heatmap-cell"
                  *ngFor="let count of row; let hourIndex = index"
                  [style.background-color]="
                    'rgba(59, 130, 246, ' +
                    (0.08 + heatmapCellIntensity(count) * 0.85) +
                    ')'
                  "
                  [pTooltip]="
                    count +
                    ' Events · ' +
                    weekdayLabels[dayIndex] +
                    ', ' +
                    hourIndex +
                    ':00 Uhr'
                  "
                  tooltipPosition="top">
                  <span
                    *ngIf="count > 0"
                    class="heatmap-count"
                    [ngClass]="{
                      'text-white': heatmapCellIntensity(count) > 0.55,
                    }"
                    >{{ count }}</span
                  >
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngIf="!heatmapMax" class="text-center py-5 text-500">
            <i class="fas fa-fire text-3xl mb-2 block text-300"></i>
            Keine Daten für die gewählten Filter.
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- ══════════════════ TAB 5: TOP-NUTZER ══════════════════ -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span><i class="fas fa-users mr-2"></i>Top-Nutzer</span>
      </ng-template>

      <div class="mt-3">
        <p class="text-500 text-sm mb-3">
          Aktivste Nutzer nach Anzahl Events (pseudonymisiert).
          {{ activeUsersCount }} aktive Nutzer im gewählten Zeitraum.
        </p>
        <div class="card surface-card border-round shadow-1 overflow-hidden">
          <div
            class="p-3 border-bottom-1 surface-border flex justify-content-between align-items-center">
            <span class="font-semibold text-700">Leaderboard</span>
            <span class="p-badge p-badge-info">Top {{ topUsers.length }}</span>
          </div>
          <div class="leaderboard">
            <div
              class="leaderboard-row"
              *ngFor="let u of topUsers; let i = index">
              <div
                class="leaderboard-rank"
                [ngClass]="{
                  'rank-gold': i === 0,
                  'rank-silver': i === 1,
                  'rank-bronze': i === 2,
                }"
                [attr.aria-label]="'Platz ' + (i + 1)"
                [title]="'Platz ' + (i + 1)">
                <i *ngIf="i < 3; else rankNumber" class="fas fa-trophy"></i>
                <ng-template #rankNumber>{{ i + 1 }}</ng-template>
              </div>
              <div class="leaderboard-avatar">{{ userInitials(u.userId) }}</div>
              <div class="leaderboard-info">
                <div
                  class="flex justify-content-between align-items-center mb-1">
                  <span class="text-sm font-mono text-600" [title]="u.userId">{{
                    u.userId
                  }}</span>
                  <span class="font-bold text-900">{{ u.count }}</span>
                </div>
                <div class="leaderboard-bar-track">
                  <div
                    class="leaderboard-bar-fill"
                    [style.width.%]="u.percentage"></div>
                </div>
              </div>
            </div>
            <div *ngIf="!topUsers.length" class="text-center py-5 text-500">
              <i class="fas fa-users text-3xl mb-2 block text-300"></i>
              Keine Benutzeraktivität im gewählten Zeitraum.
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
